'use client';

import { Slot } from '@radix-ui/react-slot';

// isolating this button variation in it's own component since it cannot be part of SSR

export const SlotButton = Slot;
